import { render } from "./GemMechanism10Lose.vue?vue&type=template&id=49503648&scoped=true"
const script = {}

import "./GemMechanism10Lose.vue?vue&type=style&index=0&id=49503648&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49503648"]])

export default __exports__